import Vue from 'vue'
import Router from 'vue-router'
// @ 绝对路径 检索到 .....src/
// 如果我们Router当做局部模块使用 一定要Vue.use(Router)
// 以后在组件中  可以通过this.$router  获取Router实例化对象
// 路由信息对象 this.$routes
import Login from '@/components/Login/Login'
import LuffyHeader from '@/components/Common/LuffyHeader'
import UserCenter from '@/components/Common/UserCenter'
import PracticeList from '@/components/User/PracticeList'
import Grades from '@/components/User/Grades'
import Homework from '@/components/User/Homework'
import Message from '@/components/User/message'
import Teacherlist from '@/components/User/teacherlist'
import Notifications from '@/components/User/notifications'
import Homeworkinfor from '@/components/User/Homeworkinfor'
import Homeworkinfordata from '@/components/User/Homeworkinfordata'
import Gradesinfor from '@/components/User/Gradesinfor'
import Practices from '@/components/User/Practices'
import Myinfo from '@/components/User/Myinfo'
// import ChangePassword from '@/components/User/ChangePassword'
import PracticeDetail from '@/components/User/PracticeDetail'
import examination from '@/components/assessment/examination'
import mytask from '@/components/assessment/mytask'
import examarrangement from '@/components/assessment/examarrangement'
import taskdetails from '@/components/assessment/taskdetails'
import messcenter from '@/components/assessment/messcenter'
import loadingpage from '@/components/assessment/loadingpage'
import targetpage from '@/components/assessment/targetpage'
import test from '@/components/assessment/test'
import theoryexam from '@/components/assessment/theoryexam'
import theorylist from '@/components/assessment/theorylist'
import answerlist from '@/components/assessment/answerlist'
import Course from '@/components/Course/Course'
import CourseDetail from '@/components/Course/CourseDetail'
import CourseItem  from '@/components/Course/CourseItem'
import Channel from '@/components/User/Channel'
import Questionon from '@/components/User/Questionon'
import Questime from '@/components/Login/Questime'
import Njkq from '@/components/njkq/index'
import evaluate from '@/components/Course/Evaluate'
import getzypage from '@/components/assessment/getzypage'
import result from '@/components/Common/result'
Vue.use(Router)

// 配置路由规则
export default new Router({
   linkActiveClass:'is-active',
  mode: 'hash',
  routes: [
    {
      path: '/',
      component:LuffyHeader,
      redirect:'/ucenter/practiceList',
      children:[
        {
          path:"/course",
          name:'Course',
          component:Course,
          meta:{
            keepAlive:true,
          }
        },
        //课程详情
        {
          path:"/courses/:detailId",
          name:'courseDetail',
          component:CourseDetail,
          meta:{
            keepAlive:false,
          },
          children:[
            {
              path:'details-introduce',
              component:CourseItem,
              meta:{
                keepAlive:false,
              },
            },
          ]
        },
        //用户中心
        {
          path:'ucenter',
          name:'ucenter',
          component:UserCenter,
          meta:{requireAuth:true, keepAlive:false},
          children:[
            {
              path:'practiceList',
              name:'practiceList',
              component: PracticeList,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'grades',
              name:'grades',
              component: Grades,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'homework',
              name:'homework',
              component: Homework,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'message',
              name:'message',
              component: Message,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'teacherlist',
              name:'teacherlist',
              component: Teacherlist,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'notifications',
              name:'notifications',
              component: Notifications,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'homeworkinfor',
              name:'homeworkinfor',
              component: Homeworkinfor,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'Homeworkinfordata',
              name:'Homeworkinfordata',
              component: Homeworkinfordata,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'gradesinfor',
              name:'gradesinfor',
              component: Gradesinfor,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'practices',
              name:'practices',
              component: Practices,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'Myinfo',
              name:'Myinfo',
              component: Myinfo,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'Questionon',
              name:'Questionon',
              component: Questionon,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'practiceDetail',
              name:'practiceDetail',
              component: PracticeDetail,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'evaluate',
              name:'evaluate',
              component:evaluate,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'Channel',
              name:'Channel',
              component: Channel,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'examination',
              name:'examination',
              component: examination,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'mytask',
              name:'mytask',
              component: mytask,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'examarrangement',
              name:'examarrangement',
              component: examarrangement,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'taskdetails',
              name:'taskdetails',
              component: taskdetails,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'messcenter',
              name:'messcenter',
              component: messcenter,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'theoryexam',
              name:'theoryexam',
              component: theoryexam,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'theorylist',
              name:'theorylist',
              component: theorylist,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'answerlist',
              name:'answerlist',
              component: answerlist,
              meta:{
                keepAlive:true,
              },
            },

          ]
        },
      ]
    },
    {
      path:'/njkq',
      name:'Njkq',
      component:Njkq,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/login',
      name:'Login',
      component:Login,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/result',
      name:'result',
      component:result,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/Questime',
      name:'Questime',
      component: Questime,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/loadingpage',
      name:'loadingpage',
      component: loadingpage,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/targetpage/:detailId',
      name:'targetpage',
      component: targetpage,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/getzypage/:detailId',
      name:'getzypage',
      component: getzypage,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/test',
      name:'test',
      component: test,
      meta:{
        keepAlive:false,
      },
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js